import { useContext } from "react";
import { AppContext } from "../App";
import Label from "./Label";

export default function PreorderPopup({ data }) {
  const { getTranslatedString } = useContext(AppContext);
  const { popup, onConfirm, onCancel } = data;

  return (
    <div className="cms-popups preorder-popup">
      <div className="cms-popup-content">
        {popup.img && (
          <div className="img">
            <img src={popup.img} alt={getTranslatedString(popup, "title")} />
          </div>
        )}
        <div className="cms-popup-text">
          <div className="title">{getTranslatedString(popup, "title")}</div>
          <div
            dangerouslySetInnerHTML={{
              __html: getTranslatedString(popup, "text"),
            }}
          />
          <div className="buttons">
            <button className="button" onClick={onCancel}>
              <Label number={40} />
            </button>
            <button className="button button-primary" onClick={onConfirm}>
              {getTranslatedString(popup, "button_label")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
